const UAT_HOSTNAME = "uatportal.life-cycle.co.za";

const UAT_ALLOWED_EMAILS = new Set([
  "jean@fusionflow.co.za",
  "jean@stridefinancial.co.za",
  "janny.mccarthy@fusionflow.co.za",
  "janny.mccarthy@stridefinancial.co.za",
  "zaldo.viljoen@fusionflow.co.za",
]);

export const isUatPortal = (): boolean =>
  typeof window !== "undefined" &&
  window.location.hostname === UAT_HOSTNAME;

export const isEmailAllowedOnUat = (email?: string | null): boolean => {
  if (!isUatPortal()) return true;
  if (!email) return false;
  return UAT_ALLOWED_EMAILS.has(email.trim().toLowerCase());
};
